var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMessageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5C9.47715 5 5 9.47715 5 15C5 17.1152 5.65531 19.0736 6.77396 20.6879C7.14417 21.2222 7.23341 21.9355 6.94016 22.5665L5.80911 25H15C20.5229 25 25 20.5229 25 15C25 9.47715 20.5229 5 15 5ZM2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C21.9036 2.5 27.5 8.09644 27.5 15C27.5 21.9036 21.9036 27.5 15 27.5H4.82699C3.40921 27.5 2.51233 25.9917 3.16757 24.752L4.52719 21.8266C3.24526 19.8636 2.5 17.5171 2.5 15Z",
    fill: "url(#paint0_linear_0_753)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.5C10 16.8096 10.5596 16.25 11.25 16.25H18.75C19.4404 16.25 20 16.8096 20 17.5C20 18.1904 19.4404 18.75 18.75 18.75H11.25C10.5596 18.75 10 18.1904 10 17.5Z",
    fill: "url(#paint1_linear_0_753)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12.5C10 11.8096 10.5596 11.25 11.25 11.25H13.75C14.4404 11.25 15 11.8096 15 12.5C15 13.1904 14.4404 13.75 13.75 13.75H11.25C10.5596 13.75 10 13.1904 10 12.5Z",
    fill: "url(#paint2_linear_0_753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_753",
    x1: 2.92049,
    y1: 2.49999,
    x2: 28.0358,
    y2: 3.05041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_753",
    x1: 19.0945,
    y1: 18.75,
    x2: 11.4674,
    y2: 15.4194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_753",
    x1: 14.5472,
    y1: 13.75,
    x2: 10.2131,
    y2: 12.8037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageActive);
export default __webpack_public_path__ + "static/media/icon_message_active.9436343791d4b109a540a820e484b4ed.svg";
export { ForwardRef as ReactComponent };